import { render, staticRenderFns } from "./SearchIcon.vue?vue&type=template&id=465cb0be&"
import script from "./SearchIcon.vue?vue&type=script&lang=js&"
export * from "./SearchIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports